import React, { PureComponent } from 'react';
import { bindActionCreators, compose } from 'redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  createQuote,
  checkoutQuote,
  finalizeQuote,
  getClient,
  getPlans,
  getQuote,
  getBroker,
  getBrokerage,
  updateClient,
  updatePlansFilter,
  updateQuote,
} from '../../store/actions';
import { logException } from '../../services/utils';
import qs from 'qs';
import find from 'lodash/find';
import get from 'lodash/get';
import LandingPassport360 from '../../components/LandingPassport360';
import LandingBOA from '../../components/LandingBOA';
import Passport360EnrollmentView from '../../components/Passport360EnrollmentView';
import BOAEnrollmentView from '../../components/BOAEnrollmentView';
import ModalEnrollmentRejection from '../../components/ModalEnrollmentRejection';
import VERTICAL_TITLES from '../../constants/verticalTitles';
import logo from './chubb-logo-dark.svg';
import includes from 'lodash/includes';
import './ClientEnrollment.css';

class ClientEnrollment extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fetchedBroker: null,
      fetchedBrokerage: null,
    };
  }

  handleNotifyError = (error = {}) => {
    logException(error);
    if (error.code === 'broker_not_licensed') {
      this.rejectionModal.show();
    } else {
      window
        .$('.ClientEnrollment')
        .pgNotification({
          message: error.message || 'Sorry, something went wrong.',
          type: 'danger',
          position: 'top-left',
        })
        .show();
    }
  };

  handleNotifySuccess(message) {
    window
      .$('.ClientEnrollment')
      .pgNotification({
        message,
        type: 'success',
        position: 'top-left',
      })
      .show();
  }

  render() {
    const {
      clients,
      newClient,
      fetchedQuoteId,
      quotes,
      match,
      location,
      getBroker,
      getBrokerage,
    } = this.props;
    const { fetchedBroker, fetchedBrokerage } = this.state;
    const query = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    // TODO: Clean this up
    // Quote ID should not be determined both here and for Enrollment view prop
    const quoteIdRegex = location.pathname.match(
      new RegExp('/products/(?:[a-zA-Z0-9]+)/enroll/([^/]+)')
    );
    const quoteId = query.quote_number || (quoteIdRegex && quoteIdRegex[1]);
    const quote = quotes[quoteId];
    const quoteBroker = get(quote, 'broker');
    const quoteBrokerage = get(quote, 'brokerage');
    const client = find(clients, { id: get(quote, 'client.id') });

    if (!quote && !fetchedBrokerage) {
      const brokerId = query.b;
      const brokerageSlug = location.pathname.match(
        new RegExp('/buy/([^/]+)')
      )[1];
      if (brokerId) {
        getBroker(brokerId).then((broker) =>
          this.setState({ fetchedBroker: broker })
        );
      }
      getBrokerage(brokerageSlug).then((brokerage) => {
        if (!brokerId) {
          this.setState({ fetchedBroker: brokerage.default_broker });
        }
        this.setState({ fetchedBrokerage: brokerage });
      });
    }

    return (
      <div className="ClientEnrollment">
        <div className="header">
          <div className="brand inline">
            <img src={logo} alt="Chubb logo" width="190" height="20" />
          </div>
          <Switch>
            <Route
              exact
              path={`${match.path}/passport360`}
              render={() => {
                return (
                  <div>
                    Prepared by {quoteBroker.name} at {quoteBrokerage.name}
                  </div>
                );
              }}
            />{' '}
            <Route
              exact
              path={`${match.path}/boa`}
              render={() => {
                return (
                  <div>
                    Prepared by {quoteBroker.name} at {quoteBrokerage.name}
                  </div>
                );
              }}
            />
            <Route
              path={`${match.path}/:brokerageSlug/business-owners-accident`}
              render={() => {
                return (
                  <div>
                    Prepared by {get(fetchedBroker, 'name')} at{' '}
                    {get(fetchedBrokerage, 'name')}
                  </div>
                );
              }}
            />
            <Route
              path={`${match.path}/:brokerageSlug/passport360`}
              render={() => {
                return (
                  <div>
                    Prepared by {get(fetchedBroker, 'name')} at{' '}
                    {get(fetchedBrokerage, 'name')}
                  </div>
                );
              }}
            />
            <Route
              path={`${match.path}/:productSlug/enroll/:quoteId`}
              render={() => (
                <div>
                  <strong>Need to contact your agent?</strong>{' '}
                  <i className="fas fa-phone" /> {quoteBroker.phone_number}
                  {' or '}
                  <i className="fas fa-envelope" />{' '}
                  <a
                    className="text-complete"
                    href={`mailto:${quoteBroker.email}`}
                  >
                    {quoteBroker.email}
                  </a>
                </div>
              )}
            />
          </Switch>
        </div>

        <div className="content">
          <Switch>
            <Route
              exact
              path={`${match.path}/passport360`}
              render={() => {
                return (
                  <LandingPassport360
                    {...this.props}
                    broker={quoteBroker}
                    brokerage={quoteBrokerage}
                    quote={quotes[query.quote_number]}
                    onNotifyError={this.handleNotifyError}
                    onNotifySuccess={this.handleNotifySuccess}
                  />
                );
              }}
            />
            <Route
              exact
              path={`${match.path}/:brokerageSlug/passport360`}
              render={() => {
                return (
                  <LandingPassport360
                    {...this.props}
                    broker={fetchedBroker}
                    brokerage={fetchedBrokerage}
                    onNotifyError={this.handleNotifyError}
                    onNotifySuccess={this.handleNotifySuccess}
                  />
                );
              }}
            />
            <Route
              exact
              path={`${match.path}/boa`}
              render={() => {
                return (
                  <LandingBOA
                    {...this.props}
                    broker={quoteBroker}
                    brokerage={quoteBrokerage}
                    quote={quotes[query.quote_number]}
                    onNotifyError={this.handleNotifyError}
                    onNotifySuccess={this.handleNotifySuccess}
                  />
                );
              }}
            />
            <Route
              exact
              path={`${match.path}/:brokerageSlug/business-owners-accident`}
              render={() => {
                return (
                  <LandingBOA
                    {...this.props}
                    broker={fetchedBroker}
                    brokerage={fetchedBrokerage}
                    onNotifyError={this.handleNotifyError}
                    onNotifySuccess={this.handleNotifySuccess}
                  />
                );
              }}
            />
            <Route
              path={`${match.path}/:productSlug/enroll/:quoteId`}
              render={({ match }) => {
                switch (match.params.productSlug) {
                  case 'boa':
                    return (
                      <BOAEnrollmentView
                        {...this.props}
                        actor="client"
                        broker={quoteBroker}
                        client={client}
                        quote={quotes[match.params.quoteId]}
                        onNotifyError={this.handleNotifyError}
                        onNotifySuccess={this.handleNotifySuccess}
                      />
                    );
                  case 'passport360':
                  default:
                    return (
                      <Passport360EnrollmentView
                        {...this.props}
                        actor="client"
                        broker={quoteBroker}
                        client={client}
                        quote={quotes[match.params.quoteId]}
                        onNotifyError={this.handleNotifyError}
                        onNotifySuccess={this.handleNotifySuccess}
                      />
                    );
                }
              }}
            />
            <Route
              path={`${match.path}/:brokerageSlug/:productSlug/start`}
              render={({ match }) => {
                switch (match.params.productSlug) {
                  case 'business-owners-accident':
                    return (
                      <BOAEnrollmentView
                        {...this.props}
                        actor="client"
                        broker={fetchedBroker}
                        quote={fetchedQuoteId && quotes[fetchedQuoteId]}
                        client={newClient}
                        isShareLinkFlow={true}
                        onNotifyError={this.handleNotifyError}
                        onNotifySuccess={this.handleNotifySuccess}
                      />
                    );
                  case 'passport360':
                  default:
                    return (
                      <Passport360EnrollmentView
                        {...this.props}
                        actor="client"
                        broker={fetchedBroker}
                        quote={fetchedQuoteId && quotes[fetchedQuoteId]}
                        client={newClient}
                        isShareLinkFlow={true}
                        onNotifyError={this.handleNotifyError}
                        onNotifySuccess={this.handleNotifySuccess}
                      />
                    );
                }
              }}
            />
          </Switch>
        </div>
        <ModalEnrollmentRejection
          verticalTitle={
            includes(location.pathname, 'passport360')
              ? VERTICAL_TITLES.passport
              : VERTICAL_TITLES.boa
          }
          ref={(c) => (this.rejectionModal = c)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authToken: state.authToken,
    clients: state.clients,
    broker: state.broker,
    brokerage: state.brokerage,
    isCheckingOutQuote: state.isCheckingOutQuote,
    isUpdatingClient: state.isUpdatingClient,
    plans: state.plans,
    plansFilter: state.plansFilter,
    quoteCheckout: state.quoteCheckout,
    quotes: state.quotes,
    newClient: state.newClient,
    fetchedQuoteId: state.fetchedQuoteId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createQuote,
      checkoutQuote,
      finalizeQuote,
      getClient,
      getPlans,
      getQuote,
      getBroker,
      getBrokerage,
      updateClient,
      updatePlansFilter,
      updateQuote,
    },
    dispatch
  );

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(ClientEnrollment);
